import { createContext } from 'react';
export var PeopleRoleSelectContext = /*#__PURE__*/createContext({
  changeNodes: function changeNodes() {},
  memberNodes: [],
  groupNodes: [],
  mode: 'select'
});